import { modalPro, modalSignup } from './modal_funnel_util';

const getPermissionsFromContext = context => {
  const permissions = [];
  if (!context) {
    return permissions;
  }
  const { currentUser, proUser, adminUser, gpsiesUser, mobileBrowser } = context;
  if (currentUser) {
    permissions.push('user');
  }
  if (proUser) {
    permissions.push('pro');
  }
  if (adminUser) {
    permissions.push('admin');
  }
  if (gpsiesUser || adminUser) {
    permissions.push('gpsies');
  }
  if (mobileBrowser) {
    permissions.push('mobile');
  }
  if (!mobileBrowser) {
    permissions.push('notMobile');
  }
  return permissions;
};

const combineACLs = acls => {
  const combined = new Set();
  acls.forEach(acl => {
    if (acl) {
      acl.forEach(permission => {
        combined.add(permission);
      });
    }
  });
  return Array.from(combined);
};

const hasRequiredPermissions = (acl, permissions) => {
  if (!acl || acl.length === 0) {
    return true;
  }
  return !acl.some(required => !permissions.includes(required));
};

const ableToProceed = (acl, permissions, ref, returnToUrl) => {
  if (!acl || acl.length < 1) {
    return true;
  }
  const userRequired = acl.includes('user');
  const proRequired = acl.includes('pro');
  if ((userRequired || proRequired) && !permissions.includes('user')) {
    modalSignup(ref, returnToUrl);
    return false;
  }
  if (proRequired && !permissions.includes('pro')) {
    modalPro(ref, returnToUrl);
    return false;
  }
  return true;
};

const proRequired = acl => {
  if (!acl || acl.length < 1) {
    return false;
  }
  return acl.includes('pro');
};

const isDisabledForFree = (acl, permissions) => {
  if (!acl || acl.length < 1) {
    return false;
  }
  return acl.includes('pro') && !permissions.includes('pro');
};

export { getPermissionsFromContext, hasRequiredPermissions, ableToProceed, combineACLs, isDisabledForFree, proRequired };
